import { createSlice } from '@reduxjs/toolkit';

interface IInitialState {
  redirectUrl: string | null;
  errorMessage: string | null;
  isFormValid: boolean;
}

const initialState: IInitialState = {
  redirectUrl: null,
  errorMessage: null,
  isFormValid: false,
};

const submitFormSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setRedirectUrl(state, action) {
      state.redirectUrl = action.payload;
    },
    setErrorMessage(state, action) {
      state.errorMessage = action.payload;
      state.isFormValid = false;
    },
    deleteErrorMessage(state) {
      state.errorMessage = null;
    },
    setFormValid(state, action) {
      state.isFormValid = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  reducer: submitFormReducer,
  actions: { setRedirectUrl, setErrorMessage, setFormValid, deleteErrorMessage },
} = submitFormSlice;
